module.exports = __webpack_public_path__ + "static/media/view.7eb6d959.svg";